import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Grid,
  Box,
  Button,
  Chip,
  Divider,
} from '@mui/material';
import axios from 'axios';

const ListingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const response = await axios.get(`/api/listings/${id}`);
        setListing(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch listing details');
        setLoading(false);
      }
    };

    fetchListing();
  }, [id]);

  if (loading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  if (!listing) {
    return (
      <Container>
        <Typography>Listing not found</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Typography variant="h4" component="h1" gutterBottom>
              {listing.name}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {listing.address}
            </Typography>
            <Box sx={{ my: 2 }}>
              <Chip
                label={listing.type}
                color="primary"
                sx={{ mr: 1 }}
              />
              <Chip
                label={`$${listing.price}/hour`}
                color="secondary"
              />
            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body1" paragraph>
              {listing.description}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Book This Space
              </Typography>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => navigate(`/bookings/new/${id}`)}
                sx={{ mt: 2 }}
              >
                Make a Booking
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ListingDetails; 